import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { District } from '@ascschool/model/category/district.model';
import { Province } from '@ascschool/model/category/province.model';
import { DistrictService } from '@ascschool/services/category/district.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Component({
  selector: 'app-popup-quan-huyen',
  templateUrl: './popup-quan-huyen.component.html',
  styleUrls: ['./popup-quan-huyen.component.scss']
})
export class PopupQuanHuyenComponent implements OnInit {
  validateForm = this.fb.group({
    id: [0],
    provinceId: [null, [Validators.required]],
    districtCode: [null, [Validators.required]],
    districtName: [null, [Validators.required]]
  });
  @ViewChildren('label') labelElement:any;
  @Input() value: any;
  isEditMode = false;
  district = new District();
  errorMsg: string;
  isDisabled = false;
  getProvinceACFn: (value: any) => Observable<any>;
  ProvinceSubscription: any;
  ProvinceControl = this.validateForm.controls.provinceId;
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    public utilsService: UtilsService,
    private service: DistrictService,
    private fb: FormBuilder,
    private provinceService: ProvinceService
  ) {}

  ngOnInit() {
    this.loadProvince();
    if (this.value && this.value.id > 0) {
      this.GetById(this.value.id);
      this.isEditMode = true;
    } else {
      this.district = new District();
      this.isEditMode = false;
    }
  }
  loadProvince() {
    // tslint:disable-next-line: max-line-length
    this.getProvinceACFn = (value: any) =>
      this.provinceService
        .getProvinceSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 })
        .pipe(
          map((resp) =>
            resp.results.length > 0
              ? resp.results.map((x) => ({ id: x.id, text: x.provinceName }))
              : [{ id: null, text: 'Không có dữ liệu' }]
          )
        );
    if (!this.ProvinceSubscription) {
      this.ProvinceSubscription = this.ProvinceControl.valueChanges.subscribe(() => {
        this.utilsService.bindOrUnBindTheId(
          this.district,
          'provinceId',
          this.ProvinceControl.value
        );
      });
    }
  }
  changeProvince(control: FormControl) {
    if (control.value) {
      this.ProvinceControl = control;
    }
  }
  GetById(id: number) {
    this.service.getDistrictById(id).subscribe((res: any) => {
      this.district = res; 
      this.validateForm.controls.id.setValue(res.id);
      this.validateForm.controls.districtCode.setValue(res.districtCode);
      this.validateForm.controls.districtName.setValue(res.districtName);
      this.provinceService.getProvinceById(res.provinceId).subscribe((response: any) => { 
        this.ProvinceControl.setValue({ id: response.id, text: response.provinceName });
      });
    });
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  UpdateClose() {
    if (this.validateForm.valid) {
      const value = this.validateForm.value;
      this.district.provinceId = value.provinceId.id;
      this.district.districtCode = value.districtCode;
      this.district.districtName = value.districtName;
      this.district.id = value.id;
      this.service.addOrUpdateDistrict(this.district).subscribe(
        (res) => {
          if (res.statusCode === 0) {
            this.notification(res);
            this.close();
          } else {
            this.notification(res);
          }
        },
        (error) => {
          this.msg.error('lỗi: ' + error.error.Message);
        }
      );
    }else{
      this.utilsService.showNotifyInvalidControls(this.validateForm, this.labelElement);
    }
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin: ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }
}
